import { calculateDateDifference } from '@/helpers'
import { QuotationProps } from '@/types'

export enum ReferenceColumnStatusEnum {
  'default' = 'default',
  'success' = 'success',
  'warning' = 'warning',
  'danger' = 'danger',
  'automated' = 'automated',
}

export const getReferenceColumnStatus = (record: QuotationProps) => {
  const now = new Date()
  const createdAt = new Date(record?.createdAt)

  if (record?.isAutomated || record?.isAiAutomated) {
    return ReferenceColumnStatusEnum.automated
  }

  if (
    record?.status === 'pending' &&
    calculateDateDifference(createdAt, now) > 5
  ) {
    return ReferenceColumnStatusEnum.danger
  }

  if (
    record?.status === 'pending' &&
    calculateDateDifference(createdAt, now) > 3
  ) {
    return ReferenceColumnStatusEnum.warning
  }

  if (
    record?.status === 'pending' &&
    calculateDateDifference(createdAt, now) === 0
  ) {
    return ReferenceColumnStatusEnum.success
  }

  return ReferenceColumnStatusEnum.default
}

export const getColumnDateStatus = (record: QuotationProps) => {
  const now = new Date()
  const expiresAt = new Date(record?.expiresAt)
  const diff = calculateDateDifference(expiresAt, now)

  if (diff < 1) {
    return 'danger'
  }

  if (diff < 3) {
    return 'warning'
  }

  return 'default'
}
